var map = {
	"./Arabic.json": "6301",
	"./Chinese-simplified.json": "6bd4",
	"./Chinese-traditional.json": "42a3",
	"./English.json": "bbfa",
	"./French.json": "653e",
	"./German.json": "4cab",
	"./Japanese.json": "9ced",
	"./Korean.json": "2119",
	"./Portuguese.json": "293e",
	"./Russian.json": "c598",
	"./Spanish.json": "28e6",
	"./Swedish.json": "bf25",
	"./Vietnamese.json": "0461"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";